import NewEditEducacaoInclusivaPage from "@/Pages/EducacaoInclusiva/NewEditEducacaoInclusivaPage.vue";
import DiarioAEEIndexPage from "@/Pages/EducacaoInclusiva/index.vue";
import PlanoBimestralDiarioAEE from "@/Pages/EducacaoInclusiva/PlanoBimestralAEE.vue";
import AtendimentosAEEPage from "@/Pages/EducacaoInclusiva/AtendimentosPage.vue";
import LancamentoDeFrequenciaAEEPage from "@/Pages/EducacaoInclusiva/LancamentoDeFrequenciaAEEPage.vue";
import PlanoBimestralIndividualAEE from "@/Pages/EducacaoInclusiva/PlanoBimestralIndividualAEE.vue";
import PlanosAEEPage from "@/Pages/EducacaoInclusiva/PlanosAEE/index.vue";
import PlanosAEEVisualizarPage from "@/Pages/EducacaoInclusiva/PlanosAEE/visualizar.vue";

export default [
  {
    path: "/educacao-inclusiva/",
    name: "educacaoInclusiva",
    component: DiarioAEEIndexPage,
  },
  {
    path: "/educacao-inclusiva/plano-bimestral/:gestaoDeAulaId",
    name: "educacaoInclusiva.planosBimestralAEE",
    component: PlanoBimestralDiarioAEE,
  },
  {
    path: "/educacao-inclusiva/planos-aee",
    name: "educacaoInclusiva.planosAEE",
    component: PlanosAEEPage,
  },
  {
    path: "/educacao-inclusiva/planos-aee/:id/visualizar",
    name: "educacaoInclusiva.planosAEEVisualizar",
    component: PlanosAEEVisualizarPage,
  },
  {
    path: "/educacao-inclusiva/matricula/:matricula_id/atendimentos",
    name: "educacaoInclusiva.atendimentos",
    component: AtendimentosAEEPage,
  },
  {
    path: "/educacao-inclusiva/matricula/:matricula_id/atendimentos/:atendimento_id/frequencia",
    name: "educacaoInclusiva.frequencia",
    component: LancamentoDeFrequenciaAEEPage,
  },
  {
    path: "/educacao-inclusiva/matricula/:matricula_id/plano-bimestral",
    name: "educacaoInclusiva.planoBimestralAluno",
    component: PlanoBimestralIndividualAEE,
  },
  {
    path: "/educacao-inclusiva/create/:matricula_id",
    name: "educacaoInclusiva.create",
    component: NewEditEducacaoInclusivaPage,
    props: { editing: false },
  },
  {
    path: "/educacao-inclusiva/edit/:matricula_id/:lancamento_id",
    name: "educacaoInclusiva.edit",
    component: NewEditEducacaoInclusivaPage,
    props: { editing: true },
  },
];
